import React, { useState, useEffect } from 'react';
import './settings.scss';
import nxtds_icons from '../../dashIcon';
import { __ } from '@wordpress/i18n';
var plugin_url = nxtext_ajax_object.tpgb_url;
import { nxtdash_save_data } from '../../apicall';
import { ToastContainer, toast ,Slide } from 'react-toastify';

var SettingData = [
    {
        key: 'gmap_api_switch',
        name: __('Connect Google Maps API Key', 'nexter-extension'),
        desc: __('To integrate Google Maps with your Maps Block, please enable the API, paste your Google Maps API key by clicking on the settings gear, and then save the changes.', 'nexter-extension'),
        popDesc: __('Paste your <a href = "https://developers.google.com/maps/documentation/embed/get-api-key" target="_blank" rel="noopener noreferrer"> Google Maps API Key </a>', 'nexter-extension'),
        formField: { 'googlemap_api': __('Enter API Key', 'nexter-extension') },
        docLink: 'https://nexterwp.com/help/nexter-blocks/wordpress-google-maps/?utm_source=nexter-addons&utm_medium=dashboard&utm_campaign=settings',
    },
    {
        key: 'gfont_load',
        name: __('Enable Google Fonts', 'nexter-extension'),
        desc: __('To disable Google Fonts, toggle this off. It will prevent any Google Fonts from loading and instead use the system font. If you want to avoid any Google Font requests, simply disable this option.', 'nexter-extension'),
    },
    {
        key: 'gbl_css',
        name: __('Enable Nexter Global CSS', 'nexter-extension'),
        desc: __('If you do not plan to use Global CSS from Nexter Blocks and prefer to load it from your theme, you can disable it. It reduces extra CSS & JS loading on your site, ensuring faster performance and complete control over design.', 'nexter-extension'),
    },
    {
        key: 'assets_performance',
        name: __('Show Nexter Performance in Admin Bar', 'nexter-extension'),
        desc: __('This option adds the Nexter Performance menu to the WordPress top admin bar, allowing you to purge assets for individual pages or all pages directly from any screen.', 'nexter-extension'),
    },
    {
        key: 'fontawesome_load',
        name: __('Load Font Awesome PRO Icons', 'nexter-extension'),
        desc: __('Connect Font Awesome PRO icons by adding your Font awesome API key in the settings for access to more premium icons for your website.', 'nexter-extension'),
    },
    {
        key: 'tpgb_template_load',
        name: __(' Enable Ajax Templates', 'nexter-extension'),
        desc: __('Load templates using Ajax mode for optimal performance. This file will load after the page finishes loading and will dynamically request content as you scroll.', 'nexter-extension'),
        link: { href: 'https://www.nexterwp.com/docs/enable-ajax-loading-for-wordpress-patterns-in-nexter-blocks/', text: __('Read more', 'nexter-extension') }
    },
    {
        key: 'tpgb_lazy_render',
        name: __('Lazy Rendering (SEO Friendly)', 'nexter-extension'),
        desc: __('If enabled, you can start using the class <b>nxt-lazy-load</b> in places where you want to lazy load content in an SEO-friendly way.', 'nexter-extension'),
        link: { href: 'https://www.nexterwp.com/docs/add-seo-friendly-lazy-loading-in-wordpress/', text: __('How to Use?', 'nexter-extension') }
    },
    {
        key: 'tpgb_dashicons_icon',
        name: __('Disable Dashicons', 'nexter-extension'),
        desc: __("If you don't need Dashicons from Nexter Blocks, you can disable them to reduce unnecessary CSS loading and improve your site's performance.", 'nexter-extension'),
    },
    {
        key: 'tpgb_preset_import',
        name: __('Disable Template Button', 'nexter-extension'),
        desc: __("Turn off the template import option in the Gutenberg Editor if you’re not planning to use it.", 'nexter-extension'),
    },
    {
        key: 'nxt_qab_enable',
        name: __('Disable Quick Action Bar', 'nexter-extension'),
		desc: __("Turn off the Quick Action Bar in the Gutenberg editor if you don’t plan to use it.", 'nexter-extension'),
    }
];

if ( (nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1") ) {
    // Concatenate with additional settings
    SettingData = SettingData.concat([
        {
            key: 'mailchmp',
            name: __('Connect Mailchimp CRM', 'nexter-extension'),
            desc: __(' Add your Mailchimp API key to connect with our Mailchimp form block and send emails directly to your CRM.'),
            popDesc: __('Paste your your <a href = "https://mailchimp.com/help/about-api-keys/" target="_blank" rel="noopener noreferrer"> Mailchimp API Key </a> & <a href = "https://mailchimp.com/help/find-audience-id/" target="_blank" rel="noopener noreferrer">  List ID </a>', 'nexter-extension'),
            formField: { 'mailchimp_api': __('Enter API Key', 'nexter-extension'), 'mailchimp_id': __('Enter Audience / List ID', 'nexter-extension') },
            docLink: '#'
        },
        {
            key: 'recaptcha',
            name: __('Connect Google reCAPTCHA', 'nexter-extension'),
            desc: __(' Add your Google reCAPTCHA Site Key and Secret Key to enable spam protection with our form blocks and secure your site.', 'nexter-extension'),
            popDesc: __('Place your <a href = "https://www.google.com/recaptcha/about/" target="_blank" rel="noopener noreferrer"> Google reCAPTCHA </a> Site Key & Secret Key', 'nexter-extension'),
            formField: { 'tpgb_site_key_recaptcha': __('Site Key reCAPTCHA v3', 'nexter-extension'), 'tpgb_secret_key_recaptcha': __('Secret Key reCAPTCHA v3', 'nexter-extension') },
            docLink: '#'
        },
        {
            key: 'tpgb_event_tracking',
            name: __(' Add Event Tracking ID', 'nexter-extension'),
            desc: __('Add your Facebook Pixel ID and GA4 ID here to enable event tracking for your clicks. This will allow you to track events directly from WordPress for your ads and GA4 analytics.', 'nexter-extension'),
            popDesc: __('Paste your your <a href = "https://support.google.com/analytics/answer/12270356" target="_blank" rel="noopener noreferrer">  GA4 Measurement ID </a> & <a href = "https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank" rel="noopener noreferrer">  Facebook Pixel </a>'),
            poplink: { href: 'https://support.google.com/analytics/answer/1008080?hl=en', text: __('Click Here', 'nexter-extension') },
            formField: { 'event_track_google': __('GA4 ID', 'nexter-extension'), 'event_track_facebook': __('Facebook Pixel ID', 'nexter-extension') },
            docLink: 'https://www.nexterwp.com/help/nexter-extras/event-tracking-for-wordpress/'
        }
    ]);

    const fontPro = SettingData.find(setting => setting.key === 'fontawesome_load');
    if (fontPro) {
        fontPro.popDesc = __("Paste your Font Awesome PRO Kit ID below <a href = 'https://fontawesome.com/license' target='_blank' rel='noopener noreferrer'> Get ID </a>", 'nexter-extension');
        fontPro.formField = { 'fontawesome_pro_kit': __('FontAwesome Pro Kit', 'nexter-extension') };
        fontPro.docLink = '#';
    }
}

const Tpgb_Settings = ({ CustomSuccessToast = () => { } }) => {
    const [enabledSettings, setEnabledSettings] = useState(nxtext_ajax_object?.dashData?.extOption || {});
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});


    const saveBlockStates = async (e, updatedStates) => {

        nxtdash_save_data(e, {
            'action': 'tpgb_connection_data_save',
            'submit-key': 'Save',
            'tpgb_connection_data': JSON.stringify(updatedStates),
            'nonce_tpgb_connection_data': nxtext_ajax_object.ajax_nonce
        })

        toast(<CustomSuccessToast />, {
            position: "top-right",
            autoClose: 800,
            limit: 1,
            closeOnClick: true,
            closeButton: false,
            pauseOnHover: false,
            hideProgressBar: true,
            transition: Slide,
            className: 'nxt-blocks-success-toast',
        });
    };

    const handleCheckboxChange = async (e, key) => {
        const newSettings = {
            ...enabledSettings,
            [key]: enabledSettings[key] === "enable" ? "disable" : "enable",
        };

        setEnabledSettings(newSettings);
        await saveBlockStates(e, newSettings);

    };

    useEffect(() => {

        if (!enabledSettings.gfont_load) {
            setEnabledSettings((prev) => ({
                ...prev,
                gfont_load: "enable",
            }));
        }

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupVisible(false);
                setPopupData(null);
                setPopupInputValue({});
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    const handleOpenPopup = (data) => {
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const handlePopupInputChange = (key, value) => {
        setPopupInputValue(prevState => ({
            ...prevState,
            [key]: value,
        }));
    };

    const handlePopupSave = async (e) => {
        if (popupData) {
            const updatedSettings = {
                ...enabledSettings,
                ...popupInputValue,
            };

            setEnabledSettings(updatedSettings);
            await saveBlockStates(e, updatedSettings);
            handleClosePopup();
        }
    };

    return (
        <div className='nxt_settings_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Blocks Settings', 'nexter-extension')}</h3>
            </div>

            <div className='nxt_field_card_Section_cover'>
                {SettingData.map((setting) => (
                    <div className='nxt_field_card' key={setting.key}>
                        <div className='nxt_card_top_detail'>
                            <div className='nxt_field_card_heading_strip'>
                                <label className='nxt_field_card_title'>{setting.name}</label>
                                <div className='nxt_toggle_with_setting'>
                                    {setting.popDesc &&
                                        <button className={'nxt-ex-btn' + (enabledSettings[setting.key] === "enable" ? ' enabled' : '')} disabled={enabledSettings[setting.key] !== "enable"} onClick={() => handleOpenPopup(setting)}>{nxtds_icons.setting}</button>
                                    }
                                    <div className="nxt_block_toggle_btn_cover">
                                        <input className="nxt_toggle_btn" id={`nxt_${setting.key}`} type="checkbox" checked={ enabledSettings[setting.key] === "enable" ||(enabledSettings[setting.key] === undefined && setting.key === "gfont_load") ? true : false} onChange={(e) => handleCheckboxChange(e, setting.key)} />
                                        <label className="switch-label" htmlFor={`nxt_${setting.key}`}>
                                            <span className="switch-button"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <p className='nxt_card_description' dangerouslySetInnerHTML={{ __html: `${setting.desc}${setting.link ? ` <a href="${setting.link.href}" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">${setting.link.text}</a>` : ''}` }} />
                        </div>
                    </div>
                ))}
            </div>

            {isPopupVisible &&
                <>
                    <div className='nxt_overlay' onClick={handleClosePopup}></div>
                    <div className='nxtext_settings_popup'>
                        <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z" /></svg>
                        <div className='nxtext_popup_heading'>
                            <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                            <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                            {/* {popupData.poplink && <a href={popupData.poplink.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{popupData.poplink.text}</a>} */}

                        </div>
                        {Object.keys(popupData.formField).map((key) => (
                            <div className='nxtext_field_card_cover' key={key}>
                                <div className='nxtext_crd_head_strip'>
                                    <label htmlFor={key} className='nxtext_secondary_heading'>{popupData.formField[key]}</label>
                                </div>
                                <div className='nxtext_field_card_bottom'>
                                    <input
                                        id={key}
                                        className="nxtext_text_field"
                                        value={popupInputValue[key] || ''}
                                        onChange={(e) => handlePopupInputChange(key, e.target.value)}
                                        type="text"
                                        placeholder={popupData.formField[key]}
                                    />
                                </div>
                            </div>
                        ))}

                        <div className='nxtext_popup_bottom'>
                            <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.docLink}>{__('Read How it Works', 'nexter-extension')}</a>
                            <button className="nxtext_blue_common_btn" onClick={(e) => handlePopupSave(e)}>{__('Save', 'nexter-extension')}</button>
                        </div>
                    </div>
                </>
            }

            <ToastContainer
                position="top-right"
                autoClose={500}
                limit={1}
                closeOnClick={true}
                closeButton={false}
                pauseOnHover={false}
                hideProgressBar={true}
                transition={Slide}
            />

        </div>
    );
}

export default Tpgb_Settings;